import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useProductDispatch, useProductStore } from '../ProductProvider';
import NavProduct from '../tabs/NavProduct';
import TabBundles from '../tabs/TabBundles';
import TabMedia from '../tabs/TabMedia';
import TabSpecs from '../tabs/TabSpecs';
import TabSupport from '../tabs/TabSupport';
import { PAGE_TYPE } from '../constants';
import styles from './index.module.scss';
import ProductContent from './ProductContent';

const theme = 'white';
const tabList = ['Product', 'Bundles', 'Support', 'Specs', 'Media'];
const generalKeyBase = 'product_12V_battery_LiFePO4';
const generalKeyTM = 'product_12V_battery_marine';

export default function Detail() {
    const { productTabActive, pageType } = useProductStore();
    const dispatch = useProductDispatch();
    const router = useRouter();
    const { query } = router;
    const tabName: any = query.tab || '';
    const generalKey = pageType == PAGE_TYPE.BASE ? generalKeyBase : generalKeyTM;

    useEffect(() => {
        if (tabName && tabList.includes(tabName)) {
            dispatch({
                type: 'changeProductTabActive',
                payload: tabName,
            });
        }
    }, [tabName]);

    return (
        <div className={styles.detail}>
            <NavProduct generalKey={generalKey} />
            <div className={`product-item-tab${productTabActive === 'Product' ? ' product-item-tab-active' : ''}`}>
                <ProductContent />
            </div>
            {productTabActive === 'Bundles' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabBundles />
                </div>
            )}
            {productTabActive === 'Support' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSupport theme={theme} generalKey={generalKey} />
                </div>
            )}
            {productTabActive === 'Specs' && (
                <div className={`product-item-tab product-item-tab-active`}>
                    <TabSpecs theme={theme} generalKey={generalKey} />
                </div>
            )}
            <div className={`product-item-tab${productTabActive === 'Media' ? ' product-item-tab-active' : ''}`}>
                <TabMedia />
            </div>
        </div>
    );
}
